module.exports = __webpack_public_path__ + "static/bilxtra_hovedside3-b56707875f0b1996129cfc3aab6c58cf.png";